











import { defineComponent } from '@vue/composition-api';

const CommonCheckBoxRenderer = defineComponent({
  props: { modelValue: { default: false } },
  // setup() {},
});

export default CommonCheckBoxRenderer;
